import request from '@/utils/request'



export function tbSysBlackQuery(data) { //黑名单 - 查询
    return request({
        method: 'get',
        url: 'tbSysBlack/query',
        params: data
    })
}

export function tbSysBlackUpdate(data) { //黑名单 - 编辑
    return request({
        method: 'post',
        url: '/tbSysBlack/update',
        data
    })
}

export function tbSysBlackDelete(data) { //黑名单 - 删除
    return request({
        method: 'post',
        url: 'tbSysBlack/delete',
        data
    })
}

export function tbSysLogQuery(data) { //日志 - 查询
    return request({
        method: 'get',
        url: 'tbSysLog/query',
        params: data
    })
}

export function tbSysBlackAdd(data) {//黑名单 - 新增
    return request({
        method: 'post',
        url: '/tbSysBlack/add',
        data
    })
}


export function tbSysDictDefinitionQuery(data) {//数字字典 - 列表
    return request({
        method: 'get',
        url: '/tbSysDictDefinition/query',
        params: data
    })
}



export function tbSysDictDefinitionAdd(data) {//数字字典 - 新增
    return request({
        method: 'post',
        url: '/tbSysDictDefinition/add',
        data
    })
}


export function tbSysDictDefinitionUpdate(data) {//数字字典 - 编辑
    return request({
        method: 'post',
        url: '/tbSysDictDefinition/update',
        data
    })
}

export function tbSysDictDefinitionDelete(data) {//数字字典 - 删除
    return request({
        method: 'post',
        url: '/tbSysDictDefinition/delete',
        data
    })
}

export function tbSysDictDetailQuery(data) {//数字字典 - 子级-列表
    return request({
        method: 'get',
        url: '/tbSysDictDetail/query',
        params: data
    })
}

export function tbSysDictDetailAdd(data) {//数字字典 - 子级-列表 新增
    return request({
        method: 'post',
        url: '/tbSysDictDetail/add',
        data
    })
}

export function tbSysDictDetailUpdate(data) {//数字字典 - 子级-列表 编辑
    return request({
        method: 'post',
        url: '/tbSysDictDetail/update',
        data
    })
}

export function tbSysDictDetailDelete(data) {//数字字典 - 子级-列表 删除
    return request({
        method: 'post',
        url: '/tbSysDictDetail/delete',
        data
    })
}


export function tbSysMenuHomeTree(data) { //左侧菜单 - 查询
    return request({
        method: 'get',
        url: '/tbSysMenu/homeTree',
        params: data
    })
}

export function tbSysMenuRoleTree(data) { //角色菜单 - 查询
    return request({
        method: 'get',
        url: '/tbSysMenu/tree',
        params: data
    })
}

export function tbSysMenuAdd(data) { //左侧菜单 - 添加
    return request({
        method: 'post',
        url: '/tbSysMenu/add',
        data
    })
}
export function tbSysMenuUpdate(data) { //左侧菜单 - 修改
    return request({
        method: 'post',
        url: '/tbSysMenu/update',
        data
    })
}

export function tbSysMenuDelete(data) { //左侧菜单 - 删除
    return request({
        method: 'post',
        url: '/tbSysMenu/delete',
        data
    })
}

export function tbSysBasicInformmation(data) { //网站基本信息 - 查询
    return request({
        method: 'get',
        url: '/tbSysSite/query',
        params: data
    })
}

export function tbSysBasicInformmationUpdate(data) { //网站基本信息 - 查询
    return request({
        method: 'post',
        url: '/tbSysSite/update',
        data
    })
}